<template>
  <div id="verusvueapp">
    <router-view />
  </div>
</template>
